import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: ""
}
const _hoisted_2 = {
  class: "flex w-full items-center justify-between",
  style: {"padding":"0px 5px 8px 5px","border-bottom":"1px solid #cfd8dc"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-2xl font-bold" }, "Riwayat Edit Pengeluaran", -1)
const _hoisted_4 = { class: "content mb-5" }
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-grey font-normal" }, "Jadwal", -1)
const _hoisted_7 = { class: "text-2xl font-bold" }
const _hoisted_8 = { class: "py-4" }
const _hoisted_9 = { class: "text-sm font-bold" }
const _hoisted_10 = { class: "text-xs font-normal text-grey" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "px-4 py-4 mb-4"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "grid grid-cols-5 gap-4 mb-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-grey text-xs font-normal" }, "Jenis Pengeluaran"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-xs font-normal" }, "Nominal Awal"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-grey text-xs font-normal" }, "Nominal Baru")
], -1)
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "col-span-2 text-grey text-base font-semibold" }
const _hoisted_16 = { class: "text-grey text-base font-semibold" }
const _hoisted_17 = { class: "col-span-2 text-primary text-base font-extrabold" }
const _hoisted_18 = {
  key: 1,
  class: "text-xs text-grey mt-4"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("em", null, "- Tidak Ada Data -", -1)
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dialog = _resolveComponent("Dialog")!

  return (!$setup.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Dialog, {
          class: "history-expense-modal",
          showHeader: true,
          visible: $setup.showModal,
          "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (($setup.showModal) = $event)),
          breakpoints: { '960px': '75vw', '640px': '90vw' },
          style: { width: '40vw' },
          modal: true,
          contentClass: "wrap-ctn-modal-default"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", null, [
                _createElementVNode("i", {
                  class: "pi pi-times cursor-pointer",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.closeDialog()))
                })
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, _toDisplayString($setup.dataSource.ScheduleName), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dataset, (data) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: data,
                  class: "history-approve"
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass($setup.showDetailId === data[0] ? 'border-top-primary' : 'border-top-grey-2')
                  }, null, 2),
                  _createElementVNode("div", {
                    class: _normalizeClass($setup.showDetailId === data[0] ? 'flex items-center justify-between header-dropdown active' : 'flex items-center justify-between header-dropdown' )
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, _toDisplayString(data[0]), 1),
                      _createElementVNode("div", _hoisted_10, _toDisplayString(`Oleh ${data[1]}`), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("span", null, [
                        _createElementVNode("i", {
                          class: _normalizeClass($setup.showDetailId === data[0] ? 'pi pi-angle-right text-2xl font-medium cursor-pointer text-primary' : 'pi pi-angle-down text-2xl font-medium cursor-pointer'),
                          onClick: ($event: any) => ($setup.openDetail(data[0]))
                        }, null, 10, _hoisted_11)
                      ])
                    ])
                  ], 2),
                  ($setup.showDetailId === data[0])
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _hoisted_13,
                        (data[2].length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data[2], (detail) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "grid grid-cols-5 gap-4",
                                  key: detail
                                }, [
                                  _createElementVNode("div", _hoisted_15, _toDisplayString(detail.ExpenseName), 1),
                                  _createElementVNode("div", _hoisted_16, _toDisplayString($setup.currencyNumberFormat(detail.Original)), 1),
                                  _createElementVNode("div", _hoisted_17, _toDisplayString($setup.currencyNumberFormat(detail.RevisionAmount)), 1)
                                ]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["visible"])
      ]))
    : _createCommentVNode("", true)
}